import React, { useState, useEffect } from "react";
import cmsApi from "../../services/cmsApi";

const TermsConditions = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [cmsData, setCmsData] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);

    const fetchContent = async () => {
      try {
        const result = await cmsApi.getPageComponents("terms");
        if (result && result.success && result.components) {
          const map = {};
          result.components.forEach((c) => { map[c.componentName] = c; });
          setCmsData(map);
        }
      } catch (e) {
        console.error("Failed to fetch terms CMS content:", e);
      }
    };
    fetchContent();

    return () => clearTimeout(timer);
  }, []);

  const sectionDefaults = {
    payments: { title: "Payments Conditions", icon: "💳" },
    admission: { title: "Admission Procedure", icon: "📝" },
    transfer: { title: "Transfer Procedure", icon: "🔄" },
    readmission: { title: "Condition for Readmission", icon: "↩️" },
    appeals: { title: "Appeals", icon: "⚖️" },
  };

  const getTitle = (id) => cmsData?.[id]?.title || sectionDefaults[id].title;

  const navigationItems = Object.entries(sectionDefaults).map(([id, val]) => ({
    id,
    title: getTitle(id),
    icon: val.icon,
  }));

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Adjust scroll position so the heading is not hidden behind the sticky navbar
      const navbar = document.querySelector("header.sticky");
      const navbarHeight = navbar
        ? navbar.getBoundingClientRect().height
        : 140; // Fallback height (Navbar uses h-32 ~= 128px)

      const extraOffset = 16; // small gap between heading and navbar
      const elementTop =
        element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementTop - navbarHeight - extraOffset,
        behavior: "smooth",
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto max-w-7xl px-4 py-6">
          <div
            className={`transition-all duration-1000 ease-out ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-5"
            }`}
          >
            {/* Breadcrumb */}
            {/*<nav className="flex mb-4 text-sm">
              <span className="text-custom-pink hover:text-custom-pink/80 cursor-pointer transition-colors">
                🏠
              </span>
              <span className="mx-2 text-gray-400">></span>
              <span className="text-gray-600">About</span>
              <span className="mx-2 text-gray-400">></span>
              <span className="text-custom-pink font-medium">
                Terms and Conditions
              </span>
            </nav>
            */}

            <h1 className="text-4xl md:text-5xl font-bold text-custom-pink mb-4">
              Terms and Conditions
            </h1>
            <div className="w-16 h-1 bg-gold rounded-full"></div>
          </div>
        </div>
      </div>

      <div className="container mx-auto max-w-7xl px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:w-1/4">
            <div
              className={`bg-white rounded-lg shadow-md p-6 sticky top-6 transition-all duration-1000 delay-300 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-5"
              }`}
            >
              <h3 className="text-lg font-bold text-custom-pink mb-4 border-b border-gray-200 pb-2">
                About JRIIT
              </h3>
              <nav className="space-y-2">
                {navigationItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className={`w-full text-left px-3 py-2 rounded-md transition-all duration-300 hover:bg-custom-pink/10 hover:text-custom-pink flex items-center space-x-2 ${
                      activeSection === item.id
                        ? "bg-custom-pink/10 text-custom-pink font-medium"
                        : "text-gray-700"
                    }`}
                  >
                    <span className="text-sm">{item.icon}</span>
                    <span className="text-sm">{item.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:w-3/4">
            <div
              className={`bg-white rounded-lg shadow-md transition-all duration-1000 delay-500 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-5"
              }`}
            >
              {navigationItems.map((section, idx) => (
                <section
                  key={section.id}
                  id={section.id}
                  className={`p-8 ${idx < navigationItems.length - 1 ? 'border-b border-gray-100' : ''}`}
                >
                  <h2 className="text-2xl font-bold text-custom-pink mb-6 flex items-center space-x-3">
                    <span className="text-2xl">{section.icon}</span>
                    <span>{section.title}</span>
                  </h2>

                  <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                    {(cmsData?.[section.id]?.content || "").split("\n\n").map((paragraph, pIdx) => (
                      <p key={pIdx}>{paragraph}</p>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
